<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" focusable="false" viewBox="0 0 16 16">
  <path fill="currentColor" d="M8 0C6.53 0 5.3.52 4.32 1.56c-2 2.12-2.3 5.86-2.33 7.59C.55 9.6 0 11 0 12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1 0-1-.55-2.4-1.99-2.85-.03-1.73-.33-5.47-2.33-7.59C10.7.52 9.47 0 8 0zm0 16c1.1 0 2-.9 2-2H6c0 1.1.9 2 2 2z"/>
</svg>
